<template>
  <div class="home-wrap">
    <div class="notice-wrap">
      <div class="notice-left-wrap">
        <div class="iconfont">&#xe6bf;</div>
        <div class="notice-content-wrap regular">{{ $t('home.notice') }}</div>
      </div>
      <div class="mid-line"></div>
      <div class="notice-right-wrap">
        <div class="notice-item-wrap">
          <div class="notice-color-wrap" style="background: #ff5a5a"></div>
          <div class="word-wrap">{{ $t('home.statusNotice2') }}</div>
        </div>
        <div class="notice-item-wrap">
          <div class="notice-color-wrap" style="background: #6bd97a"></div>
          <div class="word-wrap">{{ $t('home.statusNotice1') }}</div>
        </div>
        <div class="regularSeat" @click="showregularSeat" v-loading="regular.loading">
          <img src="@/assets/images/userseat.png" alt />
        </div>
      </div>
    </div>
    <div class="homeBottom">
      <div class="roomContainer" v-if="vueConfig.HOMESHOWTYPE == 0">
        <div class="home-content-wrap linkPointer">
          <el-row type="flex" v-if="dataList.length > 0">
            <el-col v-for="(room, index) of dataList" :key="index + room.id" class="room">
              <div @click="toDetail(room)">
                <div class="name">
                  <div class="split"></div>
                  <span>{{ $i18n.locale == 'zh' ? room.name : room.nameE }}</span>
                </div>
                <div class="infoItem">
                  <div>{{ $t('home.build') }}</div>
                  <div>{{ $i18n.locale == 'zh' ? room.buildingName : room.buildingNameE }}</div>
                </div>
                <div class="infoItem">
                  <div>{{ $t('home.floor') }}</div>
                  <div>{{ $i18n.locale == 'zh' ? room.floorName : room.floorNameE }}</div>
                </div>
                <div class="count">
                  <div class="status">
                    <div>
                      <span>{{ $t('home.total') }}：{{ parseInt(room.seatTotal) }}</span>
                    </div>
                    <div>
                      <div class="color free"></div>
                      <span>{{ $t('home.free') }}: {{ room.seatFree }}</span>
                    </div>
                  </div>
                  <progressV :free="room.seatFree" :use="parseInt(room.seatTotal) - parseInt(room.seatFree)" class="progress" />
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="empty-wrap" v-else>
            <img src="../../assets/images/empty-icon.png" alt />
            <div class="empty-desc-wrap regular">{{ $t('home.emptyNotice') }}</div>
          </div>
        </div>
        <div class="pagination-wrap">
          <el-pagination
            :key="pageKey"
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            hide-on-single-page
            :page-size="pageSize"
            :current-page.sync="currentPage"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div style="padding-top: 20px;width: 100%;" v-if="vueConfig.HOMESHOWTYPE == 1">
        <FloorLayout ref="FloorLayout" :roomList="dataList" :id="params.floorId" @clickRoomDetial="clickRoomDetial" />
      </div>
    </div>

    <!-- 常用座位 -->
    <el-drawer title="常用座位" :visible.sync="regular.show" direction="ltr">
      <div class="popup-regularSeat-item">
        <div class="item" v-for="(item, index) in regular.list" :key="index" @click="reserve(item), regular.show = false">
          <div class="text_hh">
            <p class="text_hh">{{ item.label }}</p>
            <img src="@/assets/images/seat-images/seat/free-bottom.png" alt />
          </div>
          <p class="name text_hh">{{ item.roomName }}</p>
        </div>
      </div>
    </el-drawer>
    <x-reserve-seat ref="xReserveSeat" :dateType="regular.dateType" :date="regular.date"></x-reserve-seat>
  </div>
</template>

<script>
import { findRoomDuration, findRoomSlice, checkInByQr, awaySeat, stopSeat, findCommonSeat, currentUseMake } from '@/api/index'
import progressV from '@/components/progress'
import XReserveSeat from '@/components/reserveSeat'
import utils from '@/lib/utils'
import FloorLayout from './components/FloorLayout.vue';
export default {
  components: { progressV: progressV, XReserveSeat, FloorLayout },
  data () {
    return {
      pageKey: 1,
      visible: false,
      selectDate: '',
      dataList: [],
      total: 0,
      pageSize: 12, //一页多少条数据
      currentPage: 1, //当前第几页
      defaultMach: require('@/assets/images/default.jpeg'),
      date: '',
      extending: false,
      currentBook: JSON.parse(sessionStorageProxy.getItem('currentBook')),
      vueConfig: JSON.parse(sessionStorageProxy.getItem('vueConfig')),
      params: {},
      regular: {
        show: false,
        loading: false,
        list: [],
        dateType: '',
        date: ''
      },
    }
  },
  methods: {
    // 常用座位
    async showregularSeat () {
      this.regular.loading = true
      try {
        const res = await findCommonSeat()
        console.log(res, 'resres');
        if (res.data.code == 200) {
          if (res.data.data == 0) return this.$warning(this.$t('home.regularSeatmsg'))

          this.regular.show = true
          this.regular.list = res.data.data
        }
      } catch (error) { }
      this.regular.loading = false
    },
    reserve (item) {
      this.$refs.xReserveSeat.open(item)
    },
    currentChange (event) {
      this.currentPage = event
      this.current = event
      this.findRoomDurationFun()
    },
    //跳转详情页面
    toDetail (room) {
      const { dateType, amPm } = this.params
      this.$router.push({ path: '/main/layout', query: { id: room.id, makeDate: this.date, name: room.name, nameE: room.nameE, dateType, amPm } })
    },
    clickRoomDetial (val) {
      const currentItem = this.dataList.find(item => item.id == val.markId)
      if (!currentItem) return
      this.toDetail(currentItem)
    },
    hhmmToMinute: function (hhmm) {
      var arr = hhmm.split(":");
      return Number(arr[0]) * 60 + Number(arr[1]);
    },
    //根据最小时长获取时间
    findRoomDurationFun: function (params = this.params, date = this.date, currentPage = this.currentPage) {

      this.regular.mode = params.dateType
      this.regular.date = date

      this.buildingId = params.venueId
      if (this.params == {}) { //如果筛选条件为空
        this.total = 0
        this.currentPage = 1
      }
      this.params = params
      this.date = date
      let begin = params.startTimeText == null || params.startTimeText == '' ? utils.hhmmToMinute('now') : this.hhmmToMinute(params.startTimeText.getHours() + ':' + params.startTimeText.getMinutes())
      begin = params.begin == -1 ? -1 : begin
      let end = parseInt(params.endTimeText == '' ? 0 : params.endTimeText)
      let param = {
        "beginMinute": begin,
        "currentPage": currentPage,
        "endMinute": end,
        "floorId": params.floorId,
        "minMinute": 0,
        "pageSize": this.pageSize,
        "power": params.power,
        "roomType": params.roomType,
        "sortField": "",
        "sortType": "",
        "windows": params.window
      }
      let request = findRoomDuration
      // 根据筛选时间段的类型切换请求接口，固定时长接口请求
      if (params.dateType == 1) {
        request = findRoomSlice
        param.amPm = params.amPm
      }
      // findRoomSlice
      request(param, params.venueId, date).then(res => {
        if (res.data.status) {
          this.pageKey++
          this.dataList = res.data.data.pageList
          this.total = res.data.data.totalCount

          if (this.vueConfig.HOMESHOWTYPE == 1) {
            // 楼层布局图
            this.$refs.FloorLayout.getLayOutData()
          }

        } else {
          this.$warning(res.data.message)
        }
      }).catch(error => {
        this.$warning('查询失败')
        this.roomList = []
      })
    },
    _checkIn () {
      checkInByQr().then(res => {
        if (res.data.status) {
          this._getUserBook()
          this.$success('返回成功！');
        } else {
          this.$warning(res.data.message);
        }
      })
    },
    // 暂离
    _leave () {
      this.$confirm('是否暂离?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'confirmModals'
      }).then(() => {
        awaySeat().then(res => {
          if (res.status) {
            this._getUserBook()
            this.$success(res.data);
          } else {
            this.$warning(res.message);
          }
        })
      }).catch(() => { });
    },
    // 停止使用
    _stop () {
      this.$confirm('是否结束使用?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'confirmModals'
      }).then(() => {
        stopSeat().then(res => {
          if (res.status) {
            this.$success('结束使用成功');
          } else {
            this.$warning(res.message);
          }
        })
      }).catch(() => { });
    },
    // 获取用户当前预约
    _getUserBook () {
      currentUseMake().then(res => {
        if (res.data.status) {
          let currentBook = res.data.data == null ? {} : res.data.data
          sessionStorageProxy.setItem("currentBook", JSON.stringify(currentBook))
        } else {
          this.$warning(res.data.message)
        }
      }).catch(err => {
        console.error(`获取当前有效预约Error:${err}`);
        this.$warning("服务异常，请联系管理员")
      })
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .pagination-wrap {
    padding-bottom: 40px;
    display: flex;
    align-items: center;
    background-color: #fff;
  }

  .notice-wrap {
    width: 100%;
    height: 68px;
    background: #ffffff;
    border-radius: 5px 5px 5px 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .notice-left-wrap {
      height: 100%;
      display: flex;
      align-items: center;
      min-width: 440px;

      .iconfont {
        color: #409eff;
        font-size: 30px;
        margin: 28px;
      }

      .notice-content-wrap {
        font-size: 19px;
        font-weight: 400;
        color: #8a8ea6;
        transform: translate(-13px, 0px);
      }
    }

    .mid-line {
      width: 3px;
      height: 20px;
      background: #409eff;
      margin-left: 30px;
      border-radius: 5px;
    }

    .notice-right-wrap {
      padding-left: 20px;
      display: flex;
      align-items: center;

      .notice-item-wrap {
        margin-left: 40px;
        display: flex;
        align-items: center;

        .notice-color-wrap {
          width: 17px;
          height: 4px;
          border-radius: 8px 8px 8px 8px;
          transform: translate(0px, 1px);
        }

        .word-wrap {
          margin-left: 12px;
        }
      }
    }
  }

  .homeBottom {
    display: flex;
    flex: 1;
    width: 100%;

    .roomContainer {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .flatButton {
      width: 8%;
      background-color: white;
      margin-top: 10px;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 5px;
      padding-top: 30px;

      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 80px;
        margin-bottom: 40px;

        img {
          width: 55px;
          height: 55px;
        }

        span {
          font-size: 16px;
          margin-top: 5px;
        }
      }
    }
  }

  .home-content-wrap {
    width: 100%;
    flex: 1;
    border-radius: 5px 5px 5px 5px;
    margin-top: 10px;
    border-radius: 5px;
    background-color: white;

    &/deep/.el-row {
      display: flex;
      flex-wrap: wrap;
      padding: 40px;
      box-sizing: border-box;
    }

    .room {
      border-radius: 5px;
      cursor: pointer;
      height: 190px;
      background: linear-gradient(to bottom, white, white, #b5d6ff);
      padding: 20px;
      border-radius: 10px;
      box-sizing: border-box;
      margin-bottom: 20px;
      float: left;
      padding-left: 30px;
      padding-right: 30px;
      box-shadow: 2px 2px 10px #e3e3e3;
      width: 24%;
      margin-right: 1%;
      font-family: 'SCRegular';

      .name {
        font-size: 21px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 7px;

        .split {
          height: 22px;
          width: 8px;
          background-color: #1989fa;
          border-radius: 5px;
          margin-right: 10px;
        }

        span {
          white-space: nowrap;
          /* 确保文本不换行 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
          /* 使用省略号表示文本溢出 */
          width: 100%;
          /* 设置span元素的宽度 */
        }
      }

      .infoItem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 5px;
        font-size: 17px;
        color: #606266;
      }

      .count {
        margin-top: 10px;
        color: #606266;

        .status {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 15px;

            .color {
              &.total {
                background-color: #409eff;
                width: 18px;
                height: 5px;
                border-radius: 5px;
                margin-right: 7px;
              }

              &.use {
                background-color: #ff5a5a;
                width: 18px;
                height: 5px;
                border-radius: 5px;
                margin-right: 7px;
              }

              &.free {
                background-color: #7bd387;
                width: 18px;
                height: 5px;
                border-radius: 5px;
                margin-right: 7px;
              }
            }

            .span {
              font-size: 12px;
              color: #bbb;
            }
          }
        }

        .progress {
          width: 100%;
          margin-top: 10px;
        }
      }
    }

    .empty-wrap {
      width: 100%;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: 169px;
        height: 196px;
        display: block;
      }

      .empty-desc-wrap {
        margin-top: 40px;
        font-size: 20px;
        font-weight: 400;
        color: #999;
      }
    }
  }

  .time-line-wrap {
    display: flex;
    flex-direction: column;

    .time-line-silder-wrap {
      margin-top: 10px;
      height: 6px;
      border-radius: 8px 8px 8px 8px;
      position: relative;
      background: #6bd97a;

      &.end {
        background: #ff5a5a !important;
      }

      .time-line-mork-wrap {
        height: 6px;
        position: absolute;
        background: #ff5a5a;
        border-radius: 8px 8px 8px 8px;
      }
    }

    .time-line-desc {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      position: relative;
      margin-top: 15px;

      .desc-wrap {
        font-size: 12px;
        font-weight: 400;
        position: absolute;
        color: #959595;
      }
    }
  }
}
</style>
<style lang="less">
.home-wrap {
  .el-tag {
    font-family: 'SCRegular';
    height: 25px;
    padding: 0 8px;
    line-height: 23px;
    margin-right: 10px;
  }
  .regularSeat {
    margin-left: 20px;
    cursor: pointer;
    img {
      width: 66px;
      object-fit: cover;
    }
  }

  .popup-regularSeat-item {
    width: 100%;
    display: flex;
    overflow-x: auto;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 0 10px;
    flex-wrap: wrap;
    justify-content: space-between;

    &::-webkit-scrollbar {
      width: 0;
    }

    &::-moz-scrollbar {
      width: 0;
    }

    &::-ms-scrollbar {
      width: 0;
    }

    .item {
      min-width: 21%;
      margin-right: 10px;
      height: auto;
      background: #f2f2f2;
      border-radius: 10px;
      padding: 10px 10px;
      box-sizing: border-box;
      margin: 10px 0;
      cursor: pointer;

      div {
        position: relative;
        width: 30px;
        height: 30px;
        margin: 0 auto;

        img {
          width: 30px;
          object-fit: cover;
          position: absolute;
          top: 0px;
          left: 0px;
        }

        p {
          position: relative;
          z-index: 1;
          transform: translateY(2px);
          color: #fff;
          font-size: 11px;
          text-align: center;
          padding: 0px 2px;
          box-sizing: border-box;
          width: 98%;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
  .text_hh {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    -o-text-overflow: ellipsis;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/tabs/home.vue